import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.group_id = parseInt(payload.group_id, 10)
}

var state = {
  avail_docs_settings: []
}

var getters = {
  AVAIL_DOCS_SETTINGS: (state) => {
    return state.avail_docs_settings
  }
}

var mutations = {
  SET_AVAIL_DOCS_SETTINGS: (state, payload) => {
    state.avail_docs_settings = payload
  }
}

var actions = {
  GET_AVAIL_DOCS_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/available_docs')
    if (result.status === 200) {
      context.commit('SET_AVAIL_DOCS_SETTINGS', result.data)
    }
  },
  UPDATE_AVAIL_DOCS_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/available_docs', payload)
  },
  DELETE_AVAIL_DOCS_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/available_docs?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/customer_docs_settings.js